import React, { FC, useMemo } from 'react'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Container } from '@ucheba/ui/components/Container/desktop'
import { institutionsProgramIdSelectors } from '@ucheba/store/institutions/programs/programId'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import ProgramPageContent from './ProgramPageContent'
import ProgramIdPageAboutInstitution from './ProgramIdPageAboutInstitution'
import ProgramIdPageButtons from './ProgramIdPageButtons'
import { ProgramIdBanner } from '../components/ProgramIdBanner/desktop'

const StickyBlock = styled.div`
  position: sticky;
  top: 16px;
  left: 0;
  padding-bottom: 16px;
`

const Block = styled.div`
  padding-top: 40px;
`

const LeftSidebar = styled.div`
  position: relative;
  height: 100%;
  padding-right: 32px;

  ${sm.breakpoint.lgAndDown`
    padding-right: 15px;
  `}
`

const RightSidebar = styled.div`
  position: relative;
  height: 100%;
  padding-left: 32px;

  ${sm.breakpoint.lgAndDown`
    padding-left: 15px;
  `}
`

const ProgramIdPage: FC = () => {
  const program = useSelector(institutionsProgramIdSelectors.entity)

  const programTypes = useMemo(() => program?.programType?.value, [])

  if (!program) return null

  const { institution, faculty } = program

  return (
    <>
      <Block>
        <Container>
          <Grid spacing='xlarge'>
            <GridCol uxs={5}>
              <LeftSidebar>
                <StickyBlock>
                  <ProgramIdPageAboutInstitution
                    institution={institution}
                    faculty={faculty}
                  />
                </StickyBlock>
              </LeftSidebar>
            </GridCol>

            <GridCol uxs={14}>
              <ProgramPageContent programTypes={programTypes} />
            </GridCol>

            <GridCol uxs={5}>
              <RightSidebar>
                <ProgramIdPageButtons
                  faculty={faculty}
                  institution={institution}
                  program={program}
                />
              </RightSidebar>
            </GridCol>
          </Grid>
        </Container>
      </Block>

      <ProgramIdBanner programTypes={programTypes} />
    </>
  )
}

export default ProgramIdPage
